import React from 'react';
import { string } from 'prop-types';
import { useSelector } from 'react-redux';
import classNames from 'classnames/bind';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './Swatches.css';

const cx = classNames.bind(styles);

const SwatchesSkeleton = ({ className }) => {
    const { deviceType: { isMobile = false } = {} } = useSelector(({ context }) => context);
    const swatchesToShow = isMobile ? 6 : 12;
    const containerStyles = dt(['flex', 'justify-around', 'pt-1']);

    const swatchStyles = dt([
        'h-[20px]',
        'w-[20px]',
        'rounded-[100%]',
        'relative',
        'overflow-hidden',
        'bg-light-white',
    ]);

    const swatches = Array(swatchesToShow)
        .fill(0)
        .map((swatch, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <span key={`loading-swatch-${index}`} className={cx(swatchStyles, 'loading')} />
        ));

    return (
        <div
            className={cx(containerStyles, className, 'loadingContainer', {
                containerLg: !isMobile,
            })}
        >
            {swatches}
        </div>
    );
};

SwatchesSkeleton.defaultProps = {
    className: '',
};

SwatchesSkeleton.propTypes = {
    className: string,
};

export default SwatchesSkeleton;
